// Marketing site, shipping, brand colors and store sign-in.
export default {
  // Header / footer
  "{v0} home": "الصفحة الرئيسية لـ {v0}",
  "Company": "الشركة",
  "Legal": "قانوني",
  "Blog": "المدونة",
  "Pricing": "الأسعار",
  "Privacy policy": "سياسة الخصوصية",
  "Terms of service": "شروط الخدمة",
  "Muscat, Sultanate of Oman": "مسقط، سلطنة عُمان",
  "Websites, orders, delivery and bookings for businesses in Oman and the Gulf - in Arabic and English.": "مواقع وطلبات وتوصيل وحجوزات للأنشطة التجارية في عُمان والخليج - بالعربية والإنجليزية.",
  "QR menu, POS, kitchen screen and delivery.": "قائمة QR ونقطة بيع وشاشة مطبخ وتوصيل.",
  "Products, stock, shipping and online payment.": "منتجات ومخزون وشحن ودفع إلكتروني.",
  "Salons, clinics and services booked online.": "صالونات وعيادات وخدمات تُحجز عبر الإنترنت.",

  // Landing: hero
  "Your website, orders and delivery.": "موقعك وطلباتك وتوصيلك.",
  "All in one place.": "في مكان واحد.",
  "Launch a website for your restaurant, shop or salon in minutes. Take orders and bookings, set delivery prices for every city, and get paid - in Arabic and English.": "أطلق موقعًا لمطعمك أو متجرك أو صالونك خلال دقائق. استقبل الطلبات والحجوزات، وحدّد سعر التوصيل لكل مدينة، واستلم مدفوعاتك - بالعربية والإنجليزية.",
  "See what you can do": "اكتشف ما يمكنك فعله",
  "No card needed": "بدون بطاقة بنكية",
  "Live in minutes": "جاهز خلال دقائق",
  "Local support in Oman": "دعم محلي في عُمان",
  "Bait Al Karak": "بيت الكرك",
  "Delivery across Muscat": "توصيل في جميع أنحاء مسقط",
  "Fresh every morning": "طازج كل صباح",
  "Karak tea": "شاي كرك",
  "Chicken machboos": "مكبوس دجاج",
  "Omani halwa": "حلوى عُمانية",
  "OMR": "ر.ع",
  "New order": "طلب جديد",
  "Delivery to Al Khuwair": "توصيل إلى الخوير",
  "2 items · 4.800 OMR": "منتجان · 4.800 ر.ع",
  "Today's orders": "طلبات اليوم",

  "A store dashboard with today's sales, orders and best-selling products": "لوحة تحكم متجر تعرض مبيعات اليوم والطلبات والمنتجات الأكثر مبيعًا",

  // Landing: numbers
  "business types in one platform": "أنواع أنشطة في منصة واحدة",
  "commission on your sales": "عمولة على مبيعاتك",
  "languages: Arabic and English": "لغتان: العربية والإنجليزية",
  "your website takes orders": "موقعك يستقبل الطلبات",

  // Landing: apps
  "One account, the right tools": "حساب واحد والأدوات المناسبة",
  "Made for the way your business works": "مصمَّم بالطريقة التي يعمل بها نشاطك",
  "Choose your business type when you sign up and get a dashboard built for it.": "اختر نوع نشاطك عند التسجيل واحصل على لوحة تحكم مصممة له.",
  "For restaurants & cafés": "للمطاعم والمقاهي",
  "From the table QR code to the kitchen screen": "من رمز QR على الطاولة إلى شاشة المطبخ",
  "Guests scan, order and pay from their phone. Orders reach the kitchen display instantly, and your cashier rings up walk-ins on the POS.": "يمسح الضيوف الرمز ويطلبون ويدفعون من هواتفهم. تصل الطلبات إلى شاشة المطبخ فورًا، ويسجّل الكاشير طلبات الحضور على نقطة البيع.",
  "QR menu for every table": "قائمة QR لكل طاولة",
  "POS and kitchen display": "نقطة بيع وشاشة مطبخ",
  "Delivery and pickup orders": "طلبات التوصيل والاستلام",
  "For online stores": "للمتاجر الإلكترونية",
  "A shop your customers enjoy buying from": "متجر يستمتع عملاؤك بالشراء منه",
  "Show your products with photos and options, keep stock up to date with every sale, and charge the right delivery price for every city.": "اعرض منتجاتك بالصور والخيارات، وحدّث المخزون مع كل عملية بيع، واحسب سعر التوصيل الصحيح لكل مدينة.",
  "Product galleries and variants": "معارض صور المنتجات وخياراتها",
  "Stock that updates itself": "مخزون يتحدّث تلقائيًا",
  "Delivery prices per city in Oman and Saudi Arabia": "أسعار توصيل لكل مدينة في عُمان والسعودية",
  "Low-stock email alerts": "تنبيهات بالبريد عند انخفاض المخزون",
  "For salons, clinics & services": "للصالونات والعيادات والخدمات",
  "Customers book a free slot by themselves": "يحجز العملاء الموعد المتاح بأنفسهم",
  "Publish your services and opening hours. Customers pick a time that is really free, and you see the day ahead at a glance.": "انشر خدماتك وساعات عملك. يختار العملاء وقتًا متاحًا فعلًا، وترى يومك كاملًا بنظرة واحدة.",
  "Services with price and duration": "خدمات بسعرها ومدتها",
  "Opening hours and days off": "ساعات العمل وأيام الإجازة",
  "Start with this": "ابدأ بهذا",
  "Lamb shuwa": "شواء لحم",
  "Delivery · Bawshar": "توصيل · بوشر",
  "1× Machboos": "1× مكبوس",
  "2× Lemon mint": "2× ليمون بالنعناع",
  "3× Shawarma": "3× شاورما",
  "2× Lamb shuwa": "2× شواء لحم",
  "1× Karak tea": "1× شاي كرك",
  "Muscat": "مسقط",
  "Al Seeb": "السيب",
  "Salalah": "صلالة",
  "Riyadh": "الرياض",
  "Same day": "نفس اليوم",
  "2-3 days": "2-3 أيام",
  "3-4 days": "3-4 أيام",
  "Hair cut & styling": "قص وتصفيف الشعر",
  "Choose a time on Sunday": "اختر وقتًا يوم الأحد",
  "Confirm booking": "تأكيد الحجز",

  // Landing: included
  "Included in every plan": "متضمَّن في كل باقة",
  "Everything you need to sell, nothing to install": "كل ما تحتاجه للبيع، بدون أي تثبيت",
  "Delivery areas": "مناطق التوصيل",
  "One price per city or region, free delivery from an amount you choose.": "سعر لكل مدينة أو منطقة، وتوصيل مجاني ابتداءً من مبلغ تختاره.",
  "Cash, bank transfer with receipt upload, or cards with your own Stripe account.": "نقدًا، أو تحويل بنكي مع رفع الإيصال، أو بطاقات عبر حساب Stripe الخاص بك.",
  "Send offers from your own number to customers who agreed to hear from you.": "أرسل العروض من رقمك للعملاء الذين وافقوا على استلامها.",
  "Loyalty points": "نقاط الولاء",
  "Customers earn points on every order and redeem them for rewards.": "يكسب العملاء نقاطًا مع كل طلب ويستبدلونها بمكافآت.",
  "Your own address & QR codes": "عنوانك الخاص ورموز QR",
  "A subdomain for your website and printable QR codes for tables and flyers.": "نطاق فرعي لموقعك ورموز QR قابلة للطباعة للطاولات والمنشورات.",
  "Your website and dashboard in both languages, right-to-left included.": "موقعك ولوحة تحكمك باللغتين، مع دعم الكتابة من اليمين إلى اليسار.",
  "Sales by day, best sellers and payment methods, ready to export.": "المبيعات اليومية والأكثر مبيعًا وطرق الدفع، جاهزة للتصدير.",
  "Staff accounts": "حسابات الموظفين",
  "Cashier, kitchen and manager logins with their own permissions and PINs.": "حسابات للكاشير والمطبخ والمدير بصلاحيات ورموز PIN خاصة.",

  // Landing: steps, FAQ, final call
  "Getting started": "البداية",
  "Three steps to your first order": "ثلاث خطوات إلى أول طلب",
  "A short setup guide on your dashboard tells you exactly what to do next.": "دليل إعداد قصير في لوحة التحكم يخبرك بالخطوة التالية بالضبط.",
  "Create my website": "أنشئ موقعي",
  "Pick restaurant, store or bookings and choose your website name. No card needed.": "اختر مطعمًا أو متجرًا أو حجوزات، واختر اسم موقعك. بدون بطاقة بنكية.",
  "Add your logo and products": "أضف شعارك ومنتجاتك",
  "The setup guide shows you what to do next: logo, first category, first product.": "يرشدك دليل الإعداد إلى الخطوة التالية: الشعار ثم أول فئة ثم أول منتج.",
  "Share your link and sell": "شارك رابطك وابدأ البيع",
  "Send your link on WhatsApp and Instagram, print your QR codes and take your first order.": "أرسل رابطك على واتساب وإنستغرام، واطبع رموز QR، واستقبل أول طلب.",
  "Questions": "أسئلة",
  "Good to know before you start": "معلومات مفيدة قبل أن تبدأ",
  "Something else on your mind?": "لديك سؤال آخر؟",
  "Talk to us": "تحدّث معنا",
  "How long does it take to go live?": "كم يستغرق إطلاق الموقع؟",
  "Most businesses publish their website the same day. Add your logo, a few products or services, and share your link - the setup guide walks you through it.": "تنشر معظم الأنشطة موقعها في اليوم نفسه. أضف شعارك وبعض المنتجات أو الخدمات وشارك رابطك - ودليل الإعداد يرافقك خطوة بخطوة.",
  "Do I need technical skills?": "هل أحتاج إلى خبرة تقنية؟",
  "No. Everything is done from a simple dashboard in Arabic or English. If you get stuck, our team in Muscat can help.": "لا. كل شيء يتم من لوحة تحكم بسيطة بالعربية أو الإنجليزية، وإذا احتجت مساعدة ففريقنا في مسقط جاهز.",
  "Which payment methods can my customers use?": "ما طرق الدفع المتاحة لعملائي؟",
  "Cash on delivery or pickup, bank transfer with receipt upload, and card payments through your own Stripe account.": "الدفع نقدًا عند التوصيل أو الاستلام، والتحويل البنكي مع رفع الإيصال، والدفع بالبطاقة عبر حساب Stripe الخاص بك.",
  "Can I set different delivery prices per city?": "هل يمكنني تحديد سعر توصيل مختلف لكل مدينة؟",
  "Yes. Add the main cities of Oman or Saudi Arabia in one click, or type your own areas, and give each one its own price and free-delivery amount.": "نعم. أضف المدن الرئيسية في عُمان أو السعودية بضغطة واحدة، أو اكتب مناطقك بنفسك، وحدّد لكل منها سعرًا وحدًّا للتوصيل المجاني.",
  "Do you take a commission on my sales?": "هل تأخذون عمولة على مبيعاتي؟",
  "No. You pay a fixed monthly plan; every sale is yours.": "لا. تدفع اشتراكًا شهريًا ثابتًا، وكل مبيعاتك لك.",
  "Will my website have its own address?": "هل سيكون لموقعي عنوان خاص؟",
  "Yes. Every business gets its own subdomain the moment it signs up, plus QR codes for tables, flyers and packaging.": "نعم. يحصل كل نشاط على نطاق فرعي خاص فور التسجيل، بالإضافة إلى رموز QR للطاولات والمنشورات والتغليف.",
  "Give your business the website it deserves": "امنح نشاطك الموقع الذي يستحقه",
  "Start today for free. When you need help, a real team is a message away.": "ابدأ اليوم مجانًا، وعندما تحتاج مساعدة ستجد فريقًا حقيقيًا على بُعد رسالة.",
  "Ask us on WhatsApp": "اسألنا عبر واتساب",

  // Pricing
  "Simple monthly plans. No commission.": "باقات شهرية بسيطة. بدون عمولة.",
  "Start with a free trial, then pick the plan that fits. Change or cancel any time.": "ابدأ بتجربة مجانية، ثم اختر الباقة المناسبة. يمكنك التغيير أو الإلغاء في أي وقت.",
  "Most popular": "الأكثر طلبًا",
  "Start free trial": "ابدأ التجربة المجانية",
  "Every account includes": "كل حساب يتضمن",
  "Your own website and subdomain": "موقعك الخاص ونطاق فرعي",
  "Arabic and English": "العربية والإنجليزية",
  "Orders, bookings and customers": "الطلبات والحجوزات والعملاء",
  "Cash, card and bank transfer": "نقدًا وبالبطاقة وبالتحويل البنكي",
  "Delivery areas with your own prices": "مناطق توصيل بأسعارك الخاصة",
  "No commission on your sales": "بدون عمولة على مبيعاتك",
  "year": "سنة",
  "Need something custom for a group or a franchise?": "تحتاج حلًا خاصًا لمجموعة أو امتياز تجاري؟",

  // About
  "About us": "من نحن",
  "Helping Gulf businesses sell online": "نساعد أنشطة الخليج على البيع عبر الإنترنت",
  "{v0} gives restaurants, stores and service businesses the tools big brands use - in a form a small team can run every day.": "يمنح {v0} المطاعم والمتاجر وأنشطة الخدمات الأدوات التي تستخدمها العلامات الكبرى - بشكل يستطيع فريق صغير إدارته كل يوم.",
  "We started with a simple observation: many great local businesses still take orders by phone and WhatsApp, write prices by hand, and lose orders when they are busy.": "بدأنا من ملاحظة بسيطة: كثير من الأنشطة المحلية الرائعة ما زالت تستقبل الطلبات بالهاتف وواتساب، وتكتب الأسعار يدويًا، وتفقد طلبات في أوقات الذروة.",
  "So we built one platform where a business gets its own website, receives orders and bookings, sets its delivery prices city by city, and gets paid - in Arabic and English, on any phone.": "لذلك بنينا منصة واحدة يحصل فيها النشاط على موقعه الخاص، ويستقبل الطلبات والحجوزات، ويحدد أسعار التوصيل مدينةً مدينة، ويستلم مدفوعاته - بالعربية والإنجليزية ومن أي هاتف.",
  "We are based in {v0} and we answer support ourselves.": "مقرّنا في {v0}، ونرد على طلبات الدعم بأنفسنا.",
  "Built for local businesses": "مصمَّم للأنشطة المحلية",
  "Restaurants, shops and salons in Oman and the Gulf, with Arabic first-class and prices in OMR and SAR.": "للمطاعم والمتاجر والصالونات في عُمان والخليج، بعربية كاملة وأسعار بالريال العُماني والسعودي.",
  "Online in minutes": "على الإنترنت خلال دقائق",
  "Your website, orders, delivery and bookings without hiring developers or paying commission.": "موقعك وطلباتك وتوصيلك وحجوزاتك بدون توظيف مبرمجين أو دفع عمولة.",
  "Your data stays yours": "بياناتك تبقى ملكك",
  "Card payments go straight to your account, customer data is protected, and you can export it any time.": "مدفوعات البطاقات تذهب مباشرة إلى حسابك، وبيانات العملاء محمية، ويمكنك تصديرها في أي وقت.",

  // Contact
  "Contact us": "تواصل معنا",
  "We are here to help": "نحن هنا لمساعدتك",
  "Questions about plans, setting up your website or moving from another system? Send us a message.": "لديك أسئلة عن الباقات أو إعداد موقعك أو الانتقال من نظام آخر؟ أرسل لنا رسالة.",
  "Office": "المكتب",
  "Support hours": "ساعات الدعم",
  "Sunday to Thursday, 9:00 - 18:00": "من الأحد إلى الخميس، 9:00 - 18:00",
  "Send us a message": "أرسل لنا رسالة",
  "Business name (optional)": "اسم النشاط (اختياري)",
  "Send on WhatsApp": "أرسل عبر واتساب",
  "Send by email": "أرسل بالبريد الإلكتروني",
  "Question from the website": "سؤال من الموقع",
  "Already a customer?": "هل أنت عميل لدينا؟",
  "Sign in to your dashboard - the setup guide and settings pages answer most questions.": "سجّل الدخول إلى لوحة التحكم - فدليل الإعداد وصفحات الإعدادات تجيب عن معظم الأسئلة.",

  // Legal & blog
  "Last updated": "آخر تحديث",
  "Questions about this page? Contact {v0}": "لديك أسئلة حول هذه الصفحة؟ تواصل مع {v0}",
  "{v0} min read": "قراءة {v0} دقائق",
  "Ideas to sell more, online and in store": "أفكار لتبيع أكثر، عبر الإنترنت وفي المتجر",
  "Practical guides for restaurants, shops and service businesses in Oman and the Gulf.": "أدلة عملية للمطاعم والمتاجر وأنشطة الخدمات في عُمان والخليج.",
  "All articles": "كل المقالات",
  "Try it on your own business": "جرّبه على نشاطك",
  "Create your website for free and follow the setup guide.": "أنشئ موقعك مجانًا واتبع دليل الإعداد.",
  "Keep reading": "تابع القراءة",

  // Shipping (admin)
  "Shipping": "الشحن",
  "Delivery areas and prices": "مناطق التوصيل وأسعارها",
  "Shipping & delivery": "الشحن والتوصيل",
  "Choose where you deliver and how much it costs. Customers pick their area at checkout and the price is added to their order.": "اختر أين توصل وكم تكلفة التوصيل. يختار العميل منطقته عند إتمام الطلب ويُضاف السعر إلى طلبه.",
  "Customers enter their address and choose their area.": "يُدخل العملاء عنوانهم ويختارون منطقتهم.",
  "Customers collect their order from you.": "يستلم العملاء طلباتهم منك.",
  "Start with a ready list of cities": "ابدأ بقائمة مدن جاهزة",
  "Add more cities": "أضف مدنًا أخرى",
  "Adds the main cities with one price. You can change each price afterwards, or switch off the ones you don’t deliver to.": "تُضاف المدن الرئيسية بسعر واحد، ويمكنك بعدها تغيير سعر كل مدينة أو إيقاف المدن التي لا توصل إليها.",
  "Starting price": "السعر المبدئي",
  "Add Oman cities": "أضف مدن عُمان",
  "Add Saudi cities": "أضف مدن السعودية",
  "Adding...": "جارٍ الإضافة...",
  "{v0} cities added": "تمت إضافة {v0} مدينة",
  "These cities are already in your list": "هذه المدن موجودة في قائمتك بالفعل",
  "{v0} areas · customers only see the ones switched on": "{v0} منطقة · يرى العملاء المناطق المفعّلة فقط",
  "No areas yet - delivery is free and you arrange it with the customer.": "لا توجد مناطق بعد - التوصيل مجاني وتتفق عليه مع العميل.",
  "Add area manually": "أضف منطقة يدويًا",
  "Add the cities you deliver to with the buttons above, or type your own areas.": "أضف المدن التي توصل إليها بالأزرار أعلاه، أو اكتب مناطقك بنفسك.",
  "Add a delivery area": "أضف منطقة توصيل",
  "Delivery area added": "تمت إضافة منطقة التوصيل",
  "Country": "الدولة",
  "Region / governorate": "المنطقة / المحافظة",
  "e.g. Muscat": "مثال: مسقط",
  "City or area": "المدينة أو المنطقة",
  "e.g. Al Khuwair": "مثال: الخوير",
  "Name in Arabic": "الاسم بالعربية",
  "Delivery price": "سعر التوصيل",
  "Free delivery from": "توصيل مجاني ابتداءً من",
  "Optional": "اختياري",
  "Delivery time": "مدة التوصيل",
  "e.g. Same day": "مثال: نفس اليوم",
  "Add area": "أضف المنطقة",
  "Other areas": "مناطق أخرى",
  "No region": "بدون منطقة",
  "Price for the whole region": "سعر للمنطقة كاملة",
  "Set for all": "طبّق على الكل",
  "Free from": "مجاني من",
  "Deliver to {v0}": "التوصيل إلى {v0}",
  "Remove {v0}": "إزالة {v0}",
  "Remove {v0} from your delivery areas?": "إزالة {v0} من مناطق التوصيل؟",
  "Price updated for {v0} areas": "تم تحديث السعر لـ {v0} منطقة",
  "Oman": "عُمان",
  "Saudi Arabia": "السعودية",
  "United Arab Emirates": "الإمارات",
  "Qatar": "قطر",
  "Kuwait": "الكويت",
  "Bahrain": "البحرين",
  "Enter the city or area name": "أدخل اسم المدينة أو المنطقة",
  "Enter a delivery price (0 for free)": "أدخل سعر التوصيل (0 للتوصيل المجاني)",
  "Enter a valid amount for free delivery": "أدخل مبلغًا صحيحًا للتوصيل المجاني",
  "Choose Oman or Saudi Arabia": "اختر عُمان أو السعودية",
  "Keep delivery or pickup on so customers can order": "أبقِ التوصيل أو الاستلام مفعّلًا ليتمكن العملاء من الطلب",
  "Failed to load delivery areas": "تعذّر تحميل مناطق التوصيل",
  "Failed to add the delivery area": "تعذّرت إضافة منطقة التوصيل",
  "Failed to update the delivery area": "تعذّر تحديث منطقة التوصيل",
  "Failed to delete the delivery area": "تعذّر حذف منطقة التوصيل",
  "Failed to add the cities": "تعذّرت إضافة المدن",
  "Failed to update prices": "تعذّر تحديث الأسعار",

  // Checkout & orders
  "Choose your delivery area": "اختر منطقة التوصيل",
  "Choose your country": "اختر دولتك",
  "City / area": "المدينة / المنطقة",
  "Choose your area": "اختر منطقتك",
  "Delivery time: {v0}": "مدة التوصيل: {v0}",
  "Free delivery on orders from {v0}": "توصيل مجاني للطلبات من {v0}",
  "Total before tax": "الإجمالي قبل الضريبة",
  "This store does not deliver. Please choose pickup.": "هذا المتجر لا يوفّر التوصيل. يُرجى اختيار الاستلام.",
  "This store only delivers. Please choose delivery.": "هذا المتجر يوفّر التوصيل فقط. يُرجى اختيار التوصيل.",
  "Area": "المنطقة",
  "Address": "العنوان",
  "Delivery fee": "رسوم التوصيل",

  // Brand colors
  "Brand colors": "ألوان العلامة",
  "Give your website your own colors. Buttons, links, prices and highlights use them in every template.": "امنح موقعك ألوانك الخاصة. تستخدمها الأزرار والروابط والأسعار والعناصر البارزة في كل القوالب.",
  "Use my brand colors on my website": "استخدم ألوان علامتي في موقعي",
  "When this is off, your website uses the template's own colors.": "عند إيقاف هذا الخيار، يستخدم موقعك ألوان القالب.",
  "Quick palettes": "لوحات ألوان جاهزة",
  "Ocean": "المحيط",
  "Desert sand": "رمال الصحراء",
  "Date palm": "النخيل",
  "Royal blue": "الأزرق الملكي",
  "Rose": "الوردي",
  "Charcoal": "الفحمي",
  "Main color": "اللون الرئيسي",
  "Buttons, links and your logo badge": "الأزرار والروابط وشارة شعارك",
  "Accent color": "اللون الثانوي",
  "Small highlights and focus outlines": "العناصر البارزة الصغيرة وإطارات التحديد",
  "This color is hard to read text on. Pick a darker or lighter shade.": "يصعب قراءة النص على هذا اللون. اختر درجة أغمق أو أفتح.",
  "Your store": "متجرك",
  "Popular": "الأكثر طلبًا",
  "Drinks": "المشروبات",
  "Chicken Machboos": "مكبوس دجاج",
  "Save colors": "حفظ الألوان",
  "Pick a valid color, like #1d4ed8": "اختر لونًا صحيحًا، مثل #1d4ed8",

  // Store sign-in
  "Sign-in link is invalid or expired": "رابط تسجيل الدخول غير صالح أو منتهي الصلاحية",
  "Opening your store…": "جارٍ فتح متجرك…",
  "Could not open your store": "تعذّر فتح متجرك",
};
